webpackJsonp([270961735013575],{

/***/ 1818:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/automechanika-at-the-birmingham-nec/"},"frontmatter":{"title":"Automechanika at the Birmingham NEC","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450 automechanika article header image v1-f1444eb414f4bfcb2c8bd6aa8aac6b04.jpg"}}},"original":"/img/1160x450 automechanika article header image v1.jpg"},"category":"News"}}}]}},"pathContext":{"tag":"EVENTS"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-events-840e5dea2eeabf91ef8f.js